import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsLegacyAutomationRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-automation',
	path: '/jira/servicedesk/projects/:projectKey/settings/automation',
	exact: true,
};
